module.exports = __webpack_public_path__ + "static/media/arrow-right-disabled.b4fbbd1f.svg";